import HoldingBackCommunication from '~/pages/communication/holdingBack/libs/components/HoldingBackCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const HoldingBackCommunicationPage = (props: TPageProps) => (
  <HoldingBackCommunication {...props} />
)

export default HoldingBackCommunicationPage
